const AMOUNT_LONG_MULTIPLIER = 100000;

export function amountToLong(amount: string): number {
  return Math.floor(Number(amount) * AMOUNT_LONG_MULTIPLIER);
}
